// Libs
import classNames from 'classnames/bind';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// Components, Layouts, Pages
// Others
import { BACK_TO_PREVIOUS_PAGE } from '~/utils/constants/common';
// Styles, images, icons
import styles from './BaseToolbar.module.scss';
import { icons } from '~/assets';

type Props = {
  title?: string;
  description?: string;
  children?: ReactNode;
  total?: string;
  isBack?: boolean;
  onBackToPreviousPage?: () => void;
};

const cx = classNames.bind(styles);

const BaseToolbar = (props: Props) => {
  //#region Destructuring Props
  const { title, total, children, description, isBack = false, onBackToPreviousPage } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  const navigate = useNavigate();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleBackToPreviousPage = () => {
    if (!onBackToPreviousPage) {
      navigate(BACK_TO_PREVIOUS_PAGE);
      return;
    }

    onBackToPreviousPage();
  };
  //#endregion Handle Function

  return (
    <Stack
      component={'div'}
      id='baseToolbarComponent'
      direction={'row'}
      alignItems={'center'}
      justifyContent={title ? 'space-between' : 'flex-end'}
      gap={'20px'}
      flexWrap={'wrap'}
      className={cx('container')}
    >
      <Stack direction={'row'} gap={3}>
        {isBack && (
          <IconButton color='default' onClick={handleBackToPreviousPage}>
            <img src={icons.commonIconBack} alt={t('common_alt_img')} className={cx('btnBackIcon')} />
          </IconButton>
        )}
        <Stack direction={'column'}>
          <Box className={cx('titleGroup')}>
            {title && <Typography className={cx('title')}>{title}</Typography>}

            {total && <Typography className={cx('total')}>{total}</Typography>}
          </Box>
          {description && <Typography className={cx('description')}>{description}</Typography>}
        </Stack>
      </Stack>

      <Stack
        flexShrink={0}
        direction={'row'}
        alignItems={'center'}
        justifyContent={'flex-end'}
        gap={4}
        className={cx('group')}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default BaseToolbar;
